import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { UiFormModule } from "../../shared/ui";
import { ContactListV2Component } from "./components/contact-list/contact-list.component";
import { ContactFormV2Component } from "./components/contact-form-v2/contact-form-v2.component";
import { ContactAutoDistributionComponent } from "./components/contact-auto-distribution/contact-auto-distribution.component";
import { ContactExpenseClassificationComponent } from "./components/contact-expense-classification/contact-expense-classification.component";
import { ContactFormRouteComponent } from "./components/contact-form-route/contact-form-route.component";
import { ContactDetailTabsComponent } from "./components/contact-detail-tabs/contact-detail-tabs.component";
import { ContactService } from "./services/contact.service";
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTabsModule } from '@angular/material/tabs';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { SharedModule } from "../shared/shared.module";
import { CustomerPortalSharedModule } from "../customer-portal/customer-portal-shared.module";
import { RouterModule } from "@angular/router";

@NgModule({
  declarations: [
    ContactListV2Component,
    ContactDetailTabsComponent,
    ContactFormV2Component,
    ContactAutoDistributionComponent,
    ContactExpenseClassificationComponent,
    ContactFormRouteComponent
  ],
  exports: [
    ContactListV2Component,
    ContactFormV2Component,
    ContactFormRouteComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    UiFormModule,
    FormsModule,
    SharedModule,
    RouterModule,
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatSlideToggleModule,
    MatTabsModule,
    MatAutocompleteModule,
    MatTooltipModule,
    MatDialogModule,
    CustomerPortalSharedModule
  ],
  providers: [
    ContactService
  ]
})
export class ContactModule { }
